export function cardNum(num, className,classlength) {
  const numArr = num.toString().split('');
  const card = document.getElementsByClassName(className);
  for(let i = 0; i<=classlength;i++) {
    const cur = numArr[numArr.length - (i+1)] || 0;
    card[classlength-i].style.backgroundPosition = '0px ' + (-41 * cur) + 'px';
  }
}


export function getBeforeDate() {
  let base = new Date().getTime()
  let oneDay = 24 * 3600 * 1000;
  let date = [];
  let data = [Math.random() * 300];
  let time = new Date(base);
  for (let i = 0; i < 7; i++) {
    let now = new Date(base -= oneDay);
    let month = now.getMonth()
    month = month < 9 ? '0' + (month+1) : month+1;
    let day = now.getDate();
    day = day < 10 ? '0' + day : day;
    date.push([now.getFullYear(), month, day].join(''));
    data.push(Math.round((Math.random() - 0.5) * 20 + data[i - 1]));
  }
  var newdate = date.reverse()
  console.log(newdate);
  return newdate;
}

export function secondToHour(second) {
  let hour = Math.floor(second / 3600)
  let residurmin = second - (hour * 3600)
  let min = Math.floor(residurmin / 60)
  let sec = residurmin % 60
  return hour + '时'+ min + '分'+sec + '秒'
}